// @flow
import React, { Component } from 'react'
import moment from 'moment'
import { Redirect, withRouter } from 'react-router-dom'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import SMConst from 'frontend_core/dist/constants/sm-const'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Path from 'routes/path'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import { actions as UserActions } from 'redux/modules/remote/user'
import { showErrorMessage } from 'helpers/error'
import CardHelper from 'helpers/CardHelper'

import MainTemplate from 'components/templates/MainTemplate'
import LoadingView from 'components/atoms/LoadingView'
import SelectPaymentMethodPage from 'components/pages/SelectPaymentMethodPage'
import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'
import { getBillStatementPropsForChange } from 'components/molecules/BillStatement/presenter'
import PaidyCharge from 'containers/organisms/PaidyCharge'

import graphql from './graphql'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
      reservationId: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading?: ?boolean,
    confirmActionType?: ?'approve' | 'reject',
    isShowContentsSp?: ?boolean,
    isPaidyChargeActive?: ?boolean,
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
    fetchUser: Function,
    fetchPayments: Function,
    recalcGuestAmount: Function,
    payReservation: Function,
    postPayment: Function,
    removePoint: Function,
    removeCoupon: Function,
  },
  user: {
    payments: Array<{}>,
  },
  reservationDetail: ReservationDetailState,
}

class ReservationSelectPaymentPageContainer extends Component<PropTypes, *, *> {
  requestParams: Object

  constructor(props: PropTypes) {
    super(props)
    this.onPaidyChargeSuccess = this.onPaidyChargeSuccess.bind(this)
    this.onPaidyChargeFailed = this.onPaidyChargeFailed.bind(this)
    this.onPaidyChargeClose = this.onPaidyChargeClose.bind(this)
  }

  componentDidMount() {
    const { actions, reservationDetail, match, data } = this.props
    const { detail, messages } = reservationDetail

    window.scrollTo(0, 0)

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      backedFromChangeRequest: true,
      discountMethod: 1,
      isSelectedCompany: false,
      isPaidyChargeActive: false,
    })

    actions.fetchUser({
      userId: (data.viewer || detail.user).id,
      fetched: user => {},
    })
    actions.fetchPayments({
      userId: (data.viewer || detail.user).id,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, reservationDetail, history, match } = this.props
    const { reservationDetail: prevReservationDetail } = prevProps

    // エラー系の表示
    if (
      reservationDetail.failedApproveChange !== null &&
      prevReservationDetail.failedApproveChange === null
    ) {
      showErrorMessage(reservationDetail.failedApproveChange)
    }
  }

  generateSelectPaymentMethodPageProps = () => {
    const { user, ui, reservationDetail, actions, data, config } = this.props
    const currentUser = data.viewer || {}
    const fetchedUser = user.user
    const companies = (currentUser.allCompanies || {}).results || []
    const userPoint = fetchedUser.point_balance || {}
    const billing = (reservationDetail.detail || {}).billing || {}
    const recalcBilling = (ui.recalcReservation || {}).billing || {}
    const applyPoint =
      recalcBilling.point_discount_amount > 0
        ? (recalcBilling.point_discount_amount_text || '').replace('￥', '')
        : ''

    return {
      isShowContentsSp: true,
      isCorp:
        reservationDetail.detail.use_type ===
        SMConst.ReservationUseType.Corporate,
      sidebarInbox: <ReservationSidebarContainer />,
      availablepoint: userPoint.available_amount_text,
      holdPoint: userPoint.available_amount_text,
      availablePointLately:
        billing.guest_total_amount_except_tax <= userPoint.available_amount
          ? (billing.guest_total_amount_except_tax_text || '').replace('￥', '')
          : userPoint.available_amount_text,
      showPoint: recalcBilling.point_discount_amount > 0,
      disabledPoint: recalcBilling.point_discount_amount,
      applyPoint,
      showCoupon: recalcBilling.coupon_id,
      couponCode: ui.applyCouponCode,
      disabledCoupon: recalcBilling.coupon_id,
      isOpenCreditCard: ui.isOpenCreditCard,
      onClickOpenCreditCardForm: e => {
        e.preventDefault()
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          isOpenCreditCard: !ui.isOpenCreditCard,
        })
      },
      onClickAddCreditCard: e => {
        e.preventDefault()
        const cardHelper = new CardHelper(config)
        cardHelper.generateToken(
          {
            number: (ui.cardNumber || []).join(''),
            name: ui.cardHolderName,
            cvc: ui.cardCvc,
            exp_month: ui.cardExpireMonth,
            exp_year: ui.cardExpireYear,
          },
          {
            success: response => {
              actions.postPayment({
                userId: currentUser.id,
                paymentToken: response.id,
              })
            },
            error: response => {
              antdMessage.warning(response.error.message)
              actions.setUIState(containerIds.RESERVATION_DETAIL, {
                cardNumberErrors: [response.error.message],
              })
            },
          },
        )
      },
      radioListCard: user.payments.map(p => ({
        number: `**** **** **** ${p.last4}`,
        value: p.id,
        accountHolder: p.name,
        expirationDate: `${p.exp_month}/${p.exp_year}`,
        src: imagePath(`images/www/common/card_${p.type}.png`),
      })),
      selectedCardId: ui.selectedCardId,
      onChangePaymentCard: (cardId: number) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          selectedCardId: cardId,
          paymentMethod: SMConst.PaymentMethod.Card,
          isSelectedCompany: false,
        })
        actions.recalcGuestAmount({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: Object.assign(
            {},
            {
              ...this.generateRequestParam(),
              payment_method: SMConst.PaymentMethod.Card,
            },
          ),
        })
      },
      optionListMonth: new Array(12).fill(0).map((_, i) => ({
        label: `0${i + 1}`.slice(-2),
        value: i + 1,
      })),
      optionListYear: new Array(20).fill(0).map((_, i) => ({
        label: `${moment().year() + i}`,
        value: moment().year() + i,
      })),
      cardNumber: ui.cardNumber || [],
      cardNumberErrors: ui.cardNumberErrors,
      onChangeCardNumber: (value: string, i: number) => {
        const cardNumber = ui.cardNumber || []
        cardNumber[i] = value
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          cardNumber,
        })

        if (value.length === 4 && i < 3) {
          document.getElementById(`cardNumber${i + 1}`).focus()
        } else if (value.length === 0 && i > 0) {
          document.getElementById(`cardNumber${i - 1}`).focus()
        }
      },
      cardHolderName: ui.cardHolderName,
      onChangeCardHolderName: (value: string) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          cardHolderName: value,
        })
      },
      cardExpireYear: ui.cardExpireYear,
      cardExpireMonth: ui.cardExpireMonth,
      onChangeCardExpire: (type: string, value: string) => {
        switch (type) {
          case 'year':
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              cardExpireYear: value,
            })
            break
          case 'month':
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              cardExpireMonth: value,
            })
            break
        }
      },
      cvc: ui.cardCvc || '',
      onChangeCvc: (value: string) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          cardCvc: value,
        })
      },
      paymentMethod: ui.paymentMethod,
      onChangePaymentMethod: (value: number) => {
        switch (value) {
          case SMConst.PaymentMethod.Card:
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              selectedCompanyId: null,
            })
            break
          case SMConst.PaymentMethod.Paid:
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              selectedCompanyId: null,
              selectedCardId: null,
              isSelectedCompany: false,
            })
            break
          case SMConst.PaymentMethod.Paidy:
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              selectedCardId: null,
            })
            break
        }

        actions.recalcGuestAmount({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: Object.assign(
            {},
            {
              ...this.generateRequestParam(),
              payment_method: value,
            },
          ),
        })

        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          paymentMethod: value,
        })
      },
      discountMethod: ui.discountMethod,
      onChangeDiscountMethod: (value: number) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          discountMethod: value,
        })
      },
      companies,
      paidAccountStatus: fetchedUser.paid_account_status,
      isNeedNormalPaidExamination: (ui.recalcReservation || {})
        .is_paid_normal_judge_need,
      isImmediatablePaidExamination:
        (fetchedUser.paid_account_status === null ||
          fetchedUser.paid_account_status === 0) &&
        !(ui.recalcReservation || {}).is_paid_normal_judge_need,
      isOverPaidyAvailablePeriod: (
        ui.recalcReservation ||
        reservationDetail.detail ||
        {}
      ).is_over_paidy_available_period,
      isOverPaidyUpperLimitAmount: (
        ui.recalcReservation ||
        reservationDetail.detail ||
        {}
      ).is_over_paidy_upper_limit_amount,
      onClickImmediatePaidExamination: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          redirectToPaidExamination: true,
        })
      },
      onClickCompany: (companyId: number) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          isSelectedCompany: true,
          selectedCompanyId: companyId,
        })
      },
      isSelectedCompany: ui.isSelectedCompany,
      usePoint: ui.usePoint || '',
      onChangeUsePoint: (value: string) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          usePoint: value,
          usePointErrors: null,
        })
      },
      usePointErrors: ui.usePointErrors,
      couponCode: ui.couponCode || '',
      onChangeCouponCode: (value: string) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          couponCode: value,
          couponErrors: null,
        })
      },
      couponErrors: ui.couponErrors,
      onClickApplyPoint: () => {
        actions.recalcGuestAmount({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: this.generateRequestParam(),
        })
      },
      onClickApplyAllPoint: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          usePoint: Math.min(
            billing.guest_total_amount_except_tax,
            userPoint.available_amount,
          ),
          usePointErrors: null,
        })
      },
      onClickRemovePoint: () => {
        actions.removePoint({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: this.generateRequestParam(),
        })
      },
      onClickApplyCoupon: () => {
        actions.recalcGuestAmount({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: this.generateRequestParam(),
        })
      },
      onClickRemoveCoupon: () => {
        actions.removeCoupon({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: this.generateRequestParam(),
        })
      },
      billStatementProps: getBillStatementPropsForChange(
        reservationDetail.detail,
        ui.recalcReservation || reservationDetail.detail,
      ),
      onClickBack: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          redirectToMessage: true,
        })
      },
      onClickApply: () => {
        if (
          recalcBilling &&
          recalcBilling.is_need_additional_paidy_charge_for_change
        ) {
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            isPaidyChargeActive: true,
          })
        } else {
          actions.payReservation({
            userId: currentUser.id,
            reservationId: reservationDetail.detail.id,
            requestParam: this.generateRequestParam(),
            onSuccess: () => {
              actions.setUIState(containerIds.RESERVATION_DETAIL, {
                redirectToMessage: true,
              })
            },
          })
        }
      },
      demanded: (companies.find(c => c.id === ui.selectedCompanyId) || {}).name,
      businessUseDescription: ui.businessUseDescription,
      onChangeBusinessUseDescription: (value: string) => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          businessUseDescription: value,
        })
      },
    }
  }

  generateRequestParam = (paidyPaymentId = null, paidyChargeAmount = null) => {
    const { ui, reservationDetail } = this.props
    const { detail, messages } = reservationDetail

    const param = {
      payment_method: detail.billing.payment_method,
      payment_id: null,
      is_hourly: detail.is_hourly,
      plan_id: detail.plan_id,
    }

    if (ui.usePoint && ui.discountMethod === 2) {
      param.apply_point_amount = ui.usePoint
    }
    if (ui.couponCode && ui.discountMethod === 3) {
      param.coupon_code = ui.couponCode
    }
    if (paidyPaymentId && paidyChargeAmount) {
      param.paidy_payment_id = paidyPaymentId
      param.paidy_charge_amount = paidyChargeAmount
    }

    switch (ui.paymentMethod) {
      case SMConst.PaymentMethod.Card:
        param.destination_type = SMConst.BillingDestinationType.User
        param.payment_method = SMConst.PaymentMethod.Card
        param.payment_id = ui.selectedCardId
        break
      case SMConst.PaymentMethod.Postpay:
        param.destination_type = SMConst.BillingDestinationType.User
        param.payment_method = SMConst.PaymentMethod.Postpay
        break
      case SMConst.PaymentMethod.Paid:
        param.payment_method = SMConst.PaymentMethod.Paid
        break
      case SMConst.PaymentMethod.Paidy:
        param.payment_method = SMConst.PaymentMethod.Paidy
        break
      default:
        if (ui.isSelectedCompany) {
          param.business_use_description = ui.businessUseDescription
          param.destination_type = SMConst.BillingDestinationType.Company
          param.company_id = ui.selectedCompanyId
          param.payment_method = ''
        }
        break
    }

    return param
  }

  onPaidyChargeSuccess: Function
  onPaidyChargeSuccess(paidyPaymentId, paidyChargeAmount) {
    const { actions, data, reservationDetail } = this.props
    const currentUser = data.viewer || {}

    // 2重で呼ばれないようにここでフラグを落とす
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
    })
    actions.payReservation({
      userId: currentUser.id,
      reservationId: reservationDetail.detail.id,
      requestParam: this.generateRequestParam(
        paidyPaymentId,
        paidyChargeAmount,
      ),
      onSuccess: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          redirectToMessage: true,
        })
      },
    })
  }

  onPaidyChargeFailed: Function
  onPaidyChargeFailed() {
    const { actions } = this.props
    // 2重で呼ばれないようにここでフラグを落とす
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
    })
  }

  onPaidyChargeClose: Function
  onPaidyChargeClose() {
    const { actions } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
    })
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      ui,
      actions,
    } = this.props
    const { detail } = reservationDetail

    if (ui.redirectToMessage) {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        redirectToMessage: false,
      })
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    if (ui.redirectToPaidExamination) {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        redirectToPaidExamination: false,
      })
      return (
        <Redirect
          to={Path.reservationPayExamination(match.params.reservationId)}
        />
      )
    }

    // 未承認予約がなければ直リンクした場合はメッセージ画面に戻す
    if (
      reservationDetail.detail.id &&
      !reservationDetail.detail.unapproved_reservation &&
      reservationDetail.detail.status !== SMConst.ReservationStatus.Paying
    ) {
      antdMessage.warning(
        i18n.t('page.dashboard.reservation.error.nothingHostChange'),
      )
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationSelectPayment.title', {
          id: match.params.reservationId || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <SelectPaymentMethodPage
          {...this.generateSelectPaymentMethodPageProps()}
        />
        {ui &&
          detail &&
          ui.recalcReservation &&
          ui.isPaidyChargeActive && (
            <PaidyCharge
              roomId={detail.room.id}
              rentType={detail.rent_type}
              billing={ui.recalcReservation.billing}
              onPaidyChargeSuccess={this.onPaidyChargeSuccess}
              onPaidyChargeFailed={this.onPaidyChargeFailed}
              onPaidyChargeClose={this.onPaidyChargeClose}
            />
          )}
        {ui.isLoading && <LoadingView />}
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    user: state.user,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
    ...UserActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationSelectPaymentPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationSelectPaymentPage/index.jsx